import { FormInputMoney, FormInputNumber, FormSwitch } from "@farzoom/common-ui-components";
import { Col, Row, Space } from "antd";
import { useFormContext, useWatch } from "react-hook-form";
import { createUseStyles } from "react-jss";
import { LotsSubComponent } from "./lots";
import { useEffect } from "react";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { VerticalSpace } from "@app/UI/VerticalSpace";

const useStyles = createUseStyles({
  switch: {
    "& [class*=baseInput] .ant-switch": {
      width: "60px",
    },
  },
});

export const ContractExecutionConditions = ({ lotIndex }: LotsSubComponent) => {
  const classes = useStyles();
  const { control, setValue, clearErrors, unregister } = useFormContext<BgFormInput>();
  const { formDisabled, prefix } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";
  const guarantyTypePrefix = prefix ? `${prefix}.guarantee.type` : "guarantee.type";

  const isPrepayment = useWatch({
    control,
    name: `${currentPrefix}.${lotIndex}.contractConditions.prepaymentExists`,
  });
  const isGuarantee = useWatch({
    control,
    name: `${currentPrefix}.${lotIndex}.contractConditions.requiredSecurityForGuaranteePeriod`,
  });

  const guaranteeType = useWatch({
    name: guarantyTypePrefix,
  });

  const onPrepaymentChange = (value: boolean) => {
    setValue(`${currentPrefix}.${lotIndex}.contractConditions.prepaymentExists`, value);

    if (!value) {
      unregister(`${currentPrefix}.${lotIndex}.contractConditions.prepaymentAmount`);
      clearErrors(`${currentPrefix}.${lotIndex}.contractConditions.prepaymentAmount`);
    }
  };

  const onGuaranteeChange = (value: boolean) => {
    setValue(
      `${currentPrefix}.${lotIndex}.contractConditions.requiredSecurityForGuaranteePeriod`,
      value
    );

    if (!value) {
      unregister(`${currentPrefix}.${lotIndex}.contractConditions.securityForGuaranteePeriodDays`);
      unregister(
        `${currentPrefix}.${lotIndex}.contractConditions.securityForGuaranteePeriodAmount`
      );

      clearErrors(`${currentPrefix}.${lotIndex}.contractConditions.securityForGuaranteePeriodDays`);
      clearErrors(
        `${currentPrefix}.${lotIndex}.contractConditions.securityForGuaranteePeriodAmount`
      );
    }
  };

  const resetConditions = () => {
    onPrepaymentChange(false);
    onGuaranteeChange(false);
    setValue(`${currentPrefix}.${lotIndex}.contractConditions.includedForfeit`, false)
  };

  useEffect(() => {
    if (guaranteeType !== "execution") {
      resetConditions();
    }
  }, [guaranteeType]);

  if (guaranteeType !== "execution") return null;

  return (
    <VerticalSpace>
      <Space>
        <FormSwitch
          label="Неустойки"
          className={classes.switch}
          name={`${currentPrefix}.${lotIndex}.contractConditions.includedForfeit`}
          control={control}
          checkedLabel=""
          uncheckedLabel=""
        />
      </Space>
      <VerticalSpace size="small">
        <Space>
          <FormSwitch
            label="Предусмотрен аванс"
            className={classes.switch}
            name={`${currentPrefix}.${lotIndex}.contractConditions.prepaymentExists`}
            control={control}
            checkedLabel=""
            uncheckedLabel=""
            parentOnChange={onPrepaymentChange}
          />
        </Space>
        {isPrepayment && (
          <FormInputMoney
            name={`${currentPrefix}.${lotIndex}.contractConditions.prepaymentAmount`}
            control={control}
            setValue={setValue}
            label="Сумма аванса"
            controls={false}
            disabled={formDisabled}
            maxLength={25}
            required={!formDisabled}
          />
        )}
      </VerticalSpace>

      <Row gutter={[16, 8]} align="middle">
        <Col span={24}>
          <Space>
            <FormSwitch
              label="Гарантийный период"
              className={classes.switch}
              name={`${currentPrefix}.${lotIndex}.contractConditions.requiredSecurityForGuaranteePeriod`}
              control={control}
              checkedLabel=""
              uncheckedLabel=""
              parentOnChange={onGuaranteeChange}
            />
          </Space>
        </Col>
        {isGuarantee && (
          <>
            <Col span={12}>
              <FormInputNumber
                name={`${currentPrefix}.${lotIndex}.contractConditions.securityForGuaranteePeriodDays`}
                control={control}
                setValue={setValue}
                label="Срок гарантийного периода в днях"
                controls={false}
                disabled={formDisabled}
                required={!formDisabled}
              />
            </Col>
            <Col span={12}>
              <FormInputMoney
                name={`${currentPrefix}.${lotIndex}.contractConditions.securityForGuaranteePeriodAmount`}
                control={control}
                setValue={setValue}
                label="Сумма гарантийного обслуживания"
                controls={false}
                disabled={formDisabled}
                maxLength={25}
                required={!formDisabled}
              />
            </Col>
          </>
        )}
      </Row>
    </VerticalSpace>
  );
};
